// Small original straw hat illustration resting on the title lettering.
export const StrawHat = () => (
  <svg className="straw-hat" viewBox="0 0 64 44" aria-hidden data-testid="title-straw-hat">
    <ellipse cx="32" cy="33" rx="30" ry="9" fill="#F7C948" stroke="#B9800E" strokeWidth="2" />
    <path d="M16 32 C14 6 50 6 48 32 Z" fill="#FFD166" stroke="#B9800E" strokeWidth="2" strokeLinejoin="round" />
    <path d="M15.6 24 C24 27.5 40 27.5 48.4 24 L48 32 C40 35 24 35 16 32 Z" fill="#E8475A" />
    <path d="M23 15 C26 11.5 31 10.5 35 11" stroke="#FFF3C4" strokeWidth="2.4" strokeLinecap="round" fill="none" />
    <path d="M9 36 C20 40 44 40 55 36" stroke="#E2AE2C" strokeWidth="1.6" strokeLinecap="round" fill="none" />
  </svg>
);
